module.exports = __webpack_public_path__ + "images/sprites/ui/hikakaku_logo_91017e3487a3218b531a44026d7975a8.png";